import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Login from "./pages/login/Login";
import ROUTES_NAME from "./constants/RoutesName";
import { ToastContainer } from "react-toastify";
import Instruction from "./pages/instruction/Instruction";
import Test from "./pages/test/Test";
import ContextProvider from "./context/ContextProvider";
import ThankyouPage from "./pages/thankyouPage/ThankyouPage";
import ExamScore from "./pages/examScore/ExamScore";
import DisableDevtool from "disable-devtool";
import useDevToolsDetection from "./useDevToolsDetection";
import AuthError from "./pages/AuthError";
import DashboardMain from "./pages/dashboard/dashboardMain";
import { loginByClintApi } from "./services/service";
import DisableCopyPaste from "./DisableCopyPaste";
import useWakeLock from "./useWakeLock";

function AppRoutes() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [
    candidateLoggedinStateToInstructionsPage,
    setCandidateLoggedinStateToInstructionsPage,
  ] = useState(false);
  const [examStartedState, setExamStartedState] = useState(false);
  const [candidateLoggedinToDashboard, setCandidateLoggedinToDashboard] =
    useState(false);
  const [candidateOnFaceVerification, setCandidateOnFaceVerification] =
    useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // useDevToolsDetection();
  useWakeLock();

  useEffect(() => {
    // DisableDevtool({
    //   // url: "/auth-error",
    //   disableMenu: true,
    //   clearIntervalWhenDevOpen: false,
    // });

    const examToken = sessionStorage.getItem("examToken");
    const userName = sessionStorage.getItem("userName");

    const candidateLoggedinToInstructionsPage = sessionStorage.getItem(
      "candidateLoggedinToInstructionsPage"
    );

    const examStarted = sessionStorage.getItem("examStarted");
    const dashboardAccess = sessionStorage.getItem(
      "candidateLoggedinToDashboard"
    );

    if (examToken && userName) {
      setIsLoggedIn(true);
    }
    if (dashboardAccess) {
      setCandidateLoggedinToDashboard(true);
    }

    if (candidateLoggedinToInstructionsPage) {
      setCandidateLoggedinStateToInstructionsPage(true);
    }
    if (examStarted) {
      setExamStartedState(true);
    }
  }, []);

  const urlParams = new URLSearchParams(window.location.search);
  const key = urlParams.get("transferKey");

  const loginByClint = async (data) => {
    sessionStorage.setItem("loginByClient", true);

    try {
      const response = await loginByClintApi(data);
      if (response.success) {
        window.location.href = window.location.origin;
        sessionStorage.setItem("loginByClient", true);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (key) {
      const parsedKey = JSON.parse(key);
      loginByClint(parsedKey);
      sessionStorage.setItem("transferKey", JSON.stringify(parsedKey));
    }
  }, [key]); // Run this effect whenever 'key' changes

  const handleLogin = () => {
    setIsLoggedIn(true);
    setCandidateLoggedinToDashboard(
      sessionStorage.getItem("candidateLoggedinToDashboard") === "true"
    );
  };

  return (
    <ContextProvider>
      <ToastContainer />
      <Routes location={location}>
        <Route
          path={ROUTES_NAME.LOGIN}
          element={
            isLoggedIn && examStartedState ? (
              <Navigate to={ROUTES_NAME.TEST} />
            ) : isLoggedIn && candidateLoggedinStateToInstructionsPage ? (
              <Navigate to={ROUTES_NAME.INSTRUCTION} />
            ) : isLoggedIn && candidateLoggedinToDashboard ? (
              <Navigate to={ROUTES_NAME.DASHBOARD} />
            ) : (
                <Login handleLogin={handleLogin} />
            )
          }
        />
        <Route
          path={ROUTES_NAME.INSTRUCTION}
          element={
            isLoggedIn ? <Instruction /> : <Navigate to={ROUTES_NAME.LOGIN} />
          }
        />

        <Route
          path={ROUTES_NAME.TEST}
          element={isLoggedIn ? <Test /> : <Navigate to={ROUTES_NAME.LOGIN} />}
        />

        <Route
          path={ROUTES_NAME.THANK_YOU}
          element={
            isLoggedIn ? (
              <ThankyouPage handleLogin={handleLogin} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        <Route
          path={ROUTES_NAME.DASHBOARD}
          element={
            isLoggedIn && candidateLoggedinToDashboard ? (
              <DashboardMain />
            ) : (
              <Navigate to={ROUTES_NAME.LOGIN} />
            )
          }
        />

        <Route
          path={ROUTES_NAME.REGISTRATION}
          element={
            isLoggedIn && candidateLoggedinToDashboard ? (
              <DashboardMain />
            ) : (
              <Navigate to={ROUTES_NAME.LOGIN} />
            )
          }
        />
        <Route
          path={ROUTES_NAME.EXAM_SCORE}
          element={isLoggedIn ? <ExamScore /> : <Navigate to="/" />}
        />
        <Route path={ROUTES_NAME.AUTH_ERROR} element={<AuthError />} />
        <Route path="*" element={<Navigate to={ROUTES_NAME.LOGIN} />} />
      </Routes>
    </ContextProvider>
  );
}

function App() {
  return (
    <>
      <DisableCopyPaste>
        <AppRoutes />
      </DisableCopyPaste>
    </>
  );
}

export default App;
